import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import OpportunitySourceCategoryService from "../../../Services/OpportunitySourceCategory.service";
const makeSearchArgs = {
    loadOptions: (search, options) => OpportunitySourceCategoryService.search({
        query: search,
        ids: options.ids,
        excludeIds: options.excludeIds,
    }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const OpportunitySourceCategorySearch = makeSearch(makeSearchArgs);
export const OpportunitySourceCategoryMultiSearch = makeMultiSearch(makeSearchArgs);
